import React, { useEffect, useState } from "react";
import { AppBar, Toolbar, IconButton, Typography, Button, Card, CardContent, TextField, List,Box, ListItem, ListItemText, DialogActions, Divider, Container, FormLabel, Dialog, DialogTitle, DialogContent, Grid } from "@mui/material";
import { ArrowBack, Remove, Add, Delete, Discount, ArrowForward } from "@mui/icons-material";
import GroupedCartPopup from "./modals/groupedCartItems";
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

const Cart = ({ payload, series, initialCartItems, proceed, setCart, seriesD, editMode, newDataProp, isSpecimen, tntAmount, attachments1 }) => {
  const [cartItems, setCartItems] = useState([]);
  const [discountPopup, setDiscountPopup] = useState(false);
  const [discounts, setDiscounts] = useState({})
  const [open, setOpen] = useState(false);
  const [files, setFiles] = useState([]);
  const [attachments, setAttachment] = useState([]);
  const [tentativeAmount, setTentativeAmount] = useState("");
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedPdf, setSelectedPdf] = useState(null);

  // const handleQuantityChange = (index, delta) => {
  //   setCartItems((prevCartItems) => {
  //     return prevCartItems.map((item, i) =>
  //       i === index ? { ...item, qty: Math.max(1, item.qty + delta) } : item
  //     );
  //   });


  //   let id = cartItems[index].itemId
  //   let temp = [...initialCartItems]
  //   for (let i = 0; i < temp.length; i++) {
  //     if (temp[i].data.skuId == id) {
  //       temp[i].quantity = Math.max(1, temp[i].quantity + delta)
  //       break;
  //     }
  //   }
  //   setCart(temp)
  // };
//   const parsedAttachments = React.useMemo(() => {
//   if (!attachments1) return [];

//   // If already array, return as is
//   if (Array.isArray(attachments1)) return attachments1;

//   // If string, parse JSON
//   if (typeof attachments1 === "string") {
//     try {
//       return JSON.parse(attachments1);
//     } catch (err) {
//       console.error("Invalid attachments JSON", err);
//       return [];
//     }
//   }

//   return [];
// }, [attachments1]);

const parsedAttachments = React.useMemo(() => {
  if (!attachments1) return [];

  let value = attachments1;

  try {
    // 1st parse (unwrap outer quotes)
    if (typeof value === "string") {
      value = JSON.parse(value);
    }

    // 2nd parse (actual array)
    if (typeof value === "string") {
      value = JSON.parse(value);
    }

    // ensure array
    if (Array.isArray(value)) return value;

    // single object fallback
    if (typeof value === "object") return [value];
  } catch (err) {
    console.error("Attachment parse failed:", attachments1, err);
  }

  return [];
}, [attachments1]);


  const handleQuantityChange = (index, delta) => {
  setCartItems((prev) => {
    const updated = prev.map((item, i) =>
      i === index ? { ...item, qty: Math.max(1, item.qty + delta) } : item
    );

    const id = updated[index].itemId;

    const temp = initialCartItems.map((item) =>
      item.data.skuId === id
        ? { ...item, quantity: Math.max(1, item.quantity + delta) }
        : item
    );

    setCart(temp);
    return updated;
  });
};


  // const handleRemoveItem = (index) => {
  //   setCartItems((prevCartItems) => prevCartItems.filter((_, i) => i !== index));
  //   let id = cartItems[index].itemId
  //   let temp = []
  //   for (let i = 0; i < initialCartItems.length; i++) {
  //     if (initialCartItems[i].data.skuId != id) {
  //       temp.push(initialCartItems[i])
  //       break;
  //     }
  //   }

  //   setCart(temp)
  // };
  const handleRemoveItem = (index) => {
  const id = cartItems[index].itemId;

  setCartItems((prev) => prev.filter((_, i) => i !== index));

  const temp = initialCartItems.filter(
    (item) => item.data.skuId !== id
  );

  setCart(temp);
};


  const getTotalPrice = () => {
    return cartItems.reduce((total, item) => total + (item.price * item.qty) * (1 - item.discount / 100), 0);
  };

  function setData() {
    const newCartItems = [];

    initialCartItems.forEach((order) => {
      const quantity = parseInt(order.quantity, 10) || 1;
      const group = order.group;
      const item = order.data || {};

      newCartItems.push({
        name: item?.nameSku,
        // name: group === "6HPipXSLx5" ? item.product_name : item.nameSku,
        productGroup: group,
        bookType: order.bookType || "",
        class: order.class || "",
        price:
          item.unitPrice != null
            ? parseFloat(item.unitPrice)
            : parseFloat(item.landing_cost) || 0.0,
        qty: quantity,
        series: item.seriesCategory || "",
        itemId: item.skuId || item.id,
        total: item.unitPrice != null ? (parseFloat(item.unitPrice) * quantity || 0.0) : 0.0,
        discount: item.discount ? item.discount:0,
        itemType: order.orderType,
      });
    });

    setCartItems(newCartItems);
  }
  
  useEffect(() => { setData() }, [])

  // Initialize discounts from `seriesD` prop (may be JSON string or object)
  useEffect(() => {
    if (seriesD) {
      let parsed = seriesD;
      if (typeof seriesD === 'string') {
        try {
          parsed = JSON.parse(seriesD);
        } catch (e) {
          parsed = {};
        }
      }
      setDiscounts(parsed || {});
    }
  }, [seriesD]);

  // When discounts change, apply them to cart items so payload will include updated values
  useEffect(() => {
    if (cartItems.length === 0) return;
    setCartItems((prev) =>
      prev.map((item) => ({ ...item, discount: discounts[item.series] ?? item.discount ?? 0 }))
    );
  }, [discounts]);

  useEffect(()=>{
    setTentativeAmount(tntAmount || "")
  },[editMode])

  function applyD(discountsObj) {
    let temp = [...cartItems];
    temp.forEach((ele) => {
      ele.discount = discountsObj[ele.series] ?? 0;
    });
    setDiscountPopup(false);
    setCartItems(temp);
    // Persist the discounts mapping in component state so payloadCreate picks it up
    setDiscounts(discountsObj || {});
  }

  function payloadCreate() {
    if(!editMode && payload?.orderProcess == "upload" && (payload?.orderType?.toLowerCase() == "specimen" || payload?.orderType==="Sales" || payload?.orderType==="saleS") && attachments == "") {
      alert("Please upload attachment before proceeding.")
      return;
    }
    if (payload?.orderType?.toLowerCase() != "specimen" && payload?.applyDiscount == "yes") {
      let seriesList = [];
      if (payload?.orderProcess == "upload" && payload?.uploadSeries) {
        seriesList = Array.isArray(payload.uploadSeries) ? payload.uploadSeries : [payload.uploadSeries];
      } else {
        seriesList = [...new Set(cartItems.map(item => item.series).filter(Boolean))];
      }
      if (payload && payload?.orderType !== "Specimen" && payload?.orderProcess == "upload" && tentativeAmount == "" && tentativeAmount < 0) {
        alert("Please Enter Tentative Amount");
        return;
      }
      if (payload && payload?.orderType !== "Specimen" && payload?.orderProcess === "upload" && (!tentativeAmount || Number(tentativeAmount) <= 0)) {
        alert("Please enter Tentative Amount");
        return;
      }

      const allSeriesHaveDiscount = seriesList.length > 0 &&
        seriesList.every(series => (discounts[series] ?? 0) > 0);

      if (!allSeriesHaveDiscount) {
        alert("Discount must be filled for all series");
        return;
      }
    }
    var body = { ...payload };
    body['totalAmount'] = body['orderType'].toLowerCase() == 'sales' ? getTotalPrice() : 0;
    body['seriesDiscount'] = discounts;
    body['attachments'] = attachments || attachments1 || [];
    body['tentativeAmount'] = tentativeAmount;
    body['orders'] = cartItems.map((item) => {
      return {
        'itemId': item.itemId,
        'name': item.name,
        'price': item.price,
        'qty': item.qty,
        'productGroup': item.productGroup,
        'orderType': item.itemType ?? "",
        'total': payload['orderType'].toLowerCase() == 'sales' ? item.price * item.qty * (1 - item.discount / 100) : 0,
        'class': item.class || "",
        'bookType': item.bookType || "",
      };
    });


    proceed(cartItems, body)
  }

  const getFilePreview = (file) => {
    if (file.type.startsWith('image/')) {
      return <img src={URL.createObjectURL(file)} alt={file.name} style={{ maxWidth: '100%', height: '100px' }} />;
    } else {
      return <InsertDriveFileIcon style={{ fontSize: 50, height: "100px", }} />;
    }
  };

  const handleFileChange = (event) => {
    setFiles([...event.target.files]);
    setOpen(true);
  };

  const handleUpload = async () => {
    const formData = new FormData();
    files.forEach((file, index) => {
      formData.append(`files`, file);
    });

    try {
      const response = await window.Platform.database.uploadMultipleImages(formData);
      if (response) {
        const result = await response
        let temp = [...attachments]
        result.data.files.forEach((ele) => {
          temp.push(ele)
        });
        setAttachment(temp)

        setOpen(false);
      } else {
        alert('Failed to upload files.');
      }
    } catch (error) {
      console.error('Upload error:', error);
      alert('Error uploading files.');
    }
  };

  const handleImageClick = (file) => {
    const url = `${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`;
    window.open(url, "_blank");
    setSelectedImage(file);
    setSelectedPdf(null);
  };

  const handlePdfClick = (file) => {
    const url = `${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`;
    window.open(url, "_blank");
    setSelectedPdf(file);
    setSelectedImage(null);
  };

  const downloadFile = async (file) => {
    const url = `${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`;

    try {
      const response = await fetch(url);
      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = file.originalName || file.fileName || "download";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error("Download failed:", err);
    }
  };

  return (
    <Container>

      {newDataProp?.orderProcess == "upload" && <div>
        {/* <FormLabel sx={{ mr: 3, mt:3, fontSize: 14,  }}>Upload Attachment </FormLabel>
        <input type="file" multiple onChange={handleFileChange} /> */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            Upload Attachments
            <Button variant="outlined" component="label" className="ml-3">
              Choose Files
              <input type="file" hidden multiple onChange={handleFileChange} />
            </Button>
              {attachments?.length > 0 && <span style={{ color: "green", fontSize: "12px", fontWeight: "500", marginLeft: "30px" }}>
                {attachments.length} file(s) uploaded.
              </span>}
          </Typography>
        </Box>
        <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
          <DialogTitle>File Preview</DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              {files.map((file, index) => (
                <Grid item xs={6} key={index}>
                  {getFilePreview(file)}
                  <Typography variant="body2" noWrap>{file.name}</Typography>
                </Grid>
              ))}
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpen(false)}>Cancel</Button>
            <Button onClick={handleUpload} variant="contained" color="primary">Upload</Button>
          </DialogActions>
        </Dialog>

          {/* <div style={{ display: "flex", flexWrap: "wrap", gap: "10px"}} className="my-3">
                                      {parsedAttachments && parsedAttachments?.map((file, index) => {
                                        const isImage = /\.(jpg|jpeg|png|gif)$/i.test(file.fileName);
                                        const isPDF = /\.pdf$/i.test(file.fileName);
        
                                        return (
                                          <div key={index} style={{ cursor: "pointer" }}>
                                            {isImage && (
                                              <img
                                                //  src={`https://mittsureone.com:3001/file/${file.fileName}`}
                                                src={`${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`}
                                                alt={file.originalName}
                                                style={{
                                                  width: "150px",
                                                  height: "auto",
                                                  margin: "10px",
                                                  borderRadius: "8px",
                                                  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
                                                }}
                                                onClick={() => handleImageClick(file)}
                                              />
                                            )}
                                            {isImage && (
                                              <div style={{ textAlign: 'center' }}>
                                                <div>
                                                  <a
                                                    href={`${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    onClick={() => handleImageClick(file)}
                                                  >
                                                    {file.originalName}
                                                  </a>
                                                </div>
                                                <Button
                                                  variant="outlined"
                                                  size="small"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    downloadFile(file);
                                                  }}
                                                >
                                                  Download
                                                </Button>
        
                                              </div>
                                            )}
                                            {isPDF && (
                                              <div
                                                style={{
                                                  width: "150px",
                                                  height: "200px",
                                                  margin: "10px",
                                                  border: "1px solid #ddd",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  backgroundColor: "#f5f5f5",
                                                }}
                                                onClick={() => handlePdfClick(file)}
                                              >
                                                <Typography
                                                  variant="body2"
                                                  color="textSecondary"
                                                  textAlign="center"
                                                >
                                                  {file.originalName}
                                                </Typography>
                                              </div>
                                            )}
                                            {isPDF && (
                                              <div style={{ textAlign: 'center' }}>
                                                <div>
                                                  <a
                                                    href={`${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    onClick={() => handlePdfClick(file)}
                                                  >
                                                    {file.originalName}
                                                  </a>
                                                </div>
                                                <div>
                                                  <Button
                                                    variant="outlined"
                                                    size="small"
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      downloadFile(file);
                                                    }}
                                                  >
                                                    Download
                                                  </Button>
                                                </div>
        
                                              </div>
                                            )}
                                            {!isImage && !isPDF && (
                                              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                <a
                                                  href={`${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  onClick={() => handleImageClick(file)}
                                                >
                                                  {file.originalName}
                                                </a>
                                                <Button
                                                  variant="outlined"
                                                  size="small"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    downloadFile(file);
                                                  }}
                                                >
                                                  Download
                                                </Button>
        
                                              </div>
                                            )}
                                          </div>
                                        );
                                      })}
                                    </div> */}
                                    <Grid container spacing={3} sx={{ mt: 1 }}>
  {parsedAttachments && parsedAttachments?.map((file, index) => {
    const isImage = /\.(jpg|jpeg|png|gif)$/i.test(file.fileName);
    const isPDF = /\.pdf$/i.test(file.fileName);

    return (
      <Grid item xs={12} sm={6} md={3} key={index}>
        <Card
          elevation={3}
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            borderRadius: 2,
          }}
        >
          {/* Preview */}
          <Box
            sx={{
              height: 160,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#f5f5f5",
              cursor: "pointer",
            }}
            onClick={() =>
              isPDF ? handlePdfClick(file) : handleImageClick(file)
            }
          >
            {isImage ? (
              <img
                src={`${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`}
                alt={file.originalName}
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "cover",
                }}
              />
            ) : (
              <InsertDriveFileIcon sx={{ fontSize: 60, color: "#666" }} />
            )}
          </Box>

          {/* File Info */}
          <CardContent sx={{ p: 1.5 }}>
            <Typography
              variant="body2"
              title={file.originalName}
              sx={{
                fontWeight: 500,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {file.originalName}
            </Typography>
          </CardContent>

          {/* Actions */}
          <Box sx={{ p: 1.5, pt: 0 }}>
            <Button
              fullWidth
              size="small"
              variant="outlined"
              onClick={(e) => {
                e.stopPropagation();
                downloadFile(file);
              }}
            >
              Download
            </Button>
          </Box>
        </Card>
      </Grid>
    );
  })}
</Grid>


       {/* {payload && payload?.orderType != "Specimen" && <TextField
      //  disabled={editMode ? true : false}
          label="Tentative Amount"
          type="number"
          fullWidth
          value={tentativeAmount}
          onChange={(e) => setTentativeAmount(e.target.value)}
        />} */}
        {payload && payload?.orderType !== "Specimen" && (
          <Box sx={{ mt: 4 }}>
            <TextField
              label="Tentative Amount"
              type="number"
              fullWidth
              value={tentativeAmount}
              onChange={(e) => setTentativeAmount(e.target.value)}
            />
          </Box>
        )}

      </div>
}
      {discountPopup ? <div>


        <GroupedCartPopup
          open={discountPopup}
          onClose={() => setDiscountPopup(false)}
          cartItems={cartItems}
          seriesData={series}
          applyDiscounts={applyD}
          editMode={editMode}
          seriesD={seriesD}
          setDiscountsPer={setDiscounts}
          orderProcess={newDataProp?.orderProcess}
          uploadedSeries = {payload?.uploadSeries}
        />
      </div> :
        <div>

          {/* Cart Items */}
          <List>
            {cartItems.map((item, index) => (
              <Card key={index} sx={{ margin: 2, padding: 1 }}>
                <CardContent>
                  <ListItem>
                    <ListItemText
                      primary={item.name}
                      secondary={`Total Price: ₹${(item.price * item.qty).toFixed(2)} | Price: ₹${item.price}`}
                    />
                    <IconButton onClick={() => handleQuantityChange(index, -1)}>
                      <Remove />
                    </IconButton>
                    <Typography>{item.qty}</Typography>
                    <IconButton onClick={() => handleQuantityChange(index, 1)}>
                      <Add />
                    </IconButton>
                    <IconButton onClick={() => handleRemoveItem(index)} color="error">
                      <Delete />
                    </IconButton>
                  </ListItem>
                </CardContent>
              </Card>
            ))}
          </List>

          {/* Total & Buttons */}
          <Divider />
          <Typography variant="h6" sx={{ textAlign: "center", marginY: 2 }}>
            Total: ₹{payload.orderType.toLowerCase() === "sales" ? getTotalPrice().toFixed(2) : 0}
          </Typography>
          <div style={{ display: "flex", justifyContent: "space-between", padding: 16 }}>
            {(payload && payload?.orderType != "Specimen" && payload?.applyDiscount == "yes") && <Button variant="contained" color="success" startIcon={<Discount />} onClick={() => setDiscountPopup(!discountPopup)}>
              Discounts
            </Button>}
            <Button variant="contained" color="primary" startIcon={<ArrowForward />} onClick={() => payloadCreate()}>
              Proceed
            </Button>
          </div>
        </div>}
    </Container>
  );
};

export default Cart;